import React from 'react';
import { Controller } from 'react-hook-form';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const CustomSelectInput = ({ name, control, errors, options, label = 'Business Profiles' }) => {
  const getOptionFromValue = (value) => options.find((opt) => opt.value === value) || null;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          options={options}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option?.value === value?.value}
          value={getOptionFromValue(field.value)}
          onChange={(_, selectedOption) => field.onChange(selectedOption?.value || '')}
          renderInput={(params) => (
            <TextField {...params} label={label} error={!!errors[name]} helperText={errors[name]?.message} />
          )}
        />
      )}
    />
  );
};

export default CustomSelectInput;
